// @ts-nocheck
/**
 * bundle-waterproof.js
 * Loaded exclusively on /collections/waterproof-bundle.
 *
 * Flow:
 *   1. Customer clicks ADD on a product card.
 *   2a. Single-variant product → item added directly to the in-memory bundle.
 *   2b. Multi-variant product  → variant picker overlay opens.
 *   3. Customer selects options → clicks "ADD TO BOX" → item added.
 *   4. Bottom bar shows thumbnails + count; checkout button unlocks at 7.
 *   5. On checkout: cart is cleared, all 7 variants are posted to /cart/add.js,
 *      then the browser is redirected to /checkout.
 */

(function () {
  'use strict';

  const BUNDLE_SIZE = 3;
  const BUNDLE_PAID_VARIANT_ID = 57914079903904;

  // ── In-memory state ─────────────────────────────────────────────────────────

  const items = [];

  // ── Cached DOM refs (set in init) ───────────────────────────────────────────

  const refs = {
    grid:        null,
    count:       null,
    slots:       null,
    checkoutBtn: null,
    overlay:     null,
    panel:       null,
    content:     null,
    backdrop:    null,
    closeBtn:    null,
    qvModal:     null,
    qvBackdrop:  null,
    qvPanel:     null,
    qvBody:      null,
    qvClose:     null,
  };

  let activeCard   = null;
  let uidCounter   = 0;
  let qvCard       = null;
  let qvImgIdx     = 0;
  let qvScrollY    = 0;

  // ── Initialisation ──────────────────────────────────────────────────────────

  function init() {
    refs.grid        = document.getElementById('b3-grid');
    refs.count       = document.getElementById('b3-bar-count');
    refs.slots       = document.getElementById('b3-bar-slots');
    refs.checkoutBtn = /** @type {HTMLButtonElement} */ (document.getElementById('b3-checkout-btn'));
    refs.overlay     = document.getElementById('b3-overlay');
    refs.panel       = document.getElementById('b3-overlay-panel');
    refs.content     = document.getElementById('b3-overlay-content');
    refs.backdrop    = document.getElementById('b3-overlay-backdrop');
    refs.closeBtn    = /** @type {HTMLButtonElement} */ (document.getElementById('b3-overlay-close'));

    // Guard: bail out if any required element is missing.
    if (
      !refs.grid    || !refs.count  || !refs.slots      ||
      !refs.checkoutBtn || !refs.overlay || !refs.panel  ||
      !refs.content || !refs.backdrop    || !refs.closeBtn
    ) return;

    refs.grid.addEventListener('click', onGridClick);
    refs.grid.addEventListener('touchstart', onGridTouchStart, { passive: true });
    refs.grid.addEventListener('touchend', onGridTouchEnd, { passive: false });
    refs.slots.addEventListener('click', onSlotsClick);
    refs.checkoutBtn.addEventListener('click', onCheckout);
    refs.backdrop.addEventListener('click', closeOverlay);
    refs.closeBtn.addEventListener('click', closeOverlay);
    refs.content.addEventListener('click', onPickerClick);

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (refs.qvModal?.classList.contains('is-open')) closeQuickView();
      else if (refs.overlay?.classList.contains('is-open')) closeOverlay();
    });

    // Close desktop popover when the user scrolls (card drifts away from the panel).
    window.addEventListener('scroll', () => {
      if (refs.overlay?.classList.contains('is-open') && refs.panel?.classList.contains('is-popover')) {
        closeOverlay();
      }
    }, { passive: true });

    // On resize: if overlay is open and the viewport crossed the mobile breakpoint,
    // close it so the next open recalculates the correct mode (popover vs. bottom-sheet).
    window.addEventListener('resize', () => {
      if (refs.overlay?.classList.contains('is-open')) closeOverlay();
    }, { passive: true });

    // Quick View modal (optional — gracefully absent if IDs are missing).
    refs.qvModal    = document.getElementById('b3-qv');
    refs.qvBackdrop = document.getElementById('b3-qv-backdrop');
    refs.qvPanel    = document.getElementById('b3-qv-panel');
    refs.qvBody     = document.getElementById('b3-qv-body');
    refs.qvClose    = /** @type {HTMLButtonElement} */ (document.getElementById('b3-qv-close'));
    if (refs.qvModal && refs.qvBackdrop && refs.qvPanel && refs.qvBody && refs.qvClose) {
      refs.qvBackdrop.addEventListener('click', closeQuickView);
      refs.qvClose.addEventListener('click', closeQuickView);
      refs.qvPanel.addEventListener('click', onQVClick);
    }

    initCardGalleries();
    initFilters();

    // Verifica o carrinho REAL do Shopify (não sessionStorage, que não
    // sobrevive à troca de domínio entre a loja e o checkout). Se o
    // bundle pago já estiver no carrinho quando esta página carrega,
    // significa que o cliente provavelmente está voltando de uma
    // viagem ao checkout (concluída ou abandonada) — reseta tudo para
    // ele poder montar um novo bundle do zero.
    checkCartAndMaybeReset().then((wasReset) => {
      if (!wasReset) renderBar();
    });

    initBarVisibility();
  }

  // Mostra a barra só quando o grid está visível na tela
  function initBarVisibility() {
    const bar  = document.getElementById('b3-bar');
    const grid = refs.grid;
    if (!bar || !grid) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.01 }
    );
    observer.observe(grid);
  }

  // ── Quick-filter by product type ─────────────────────────────────────────────

  const CATEGORIES = [
    { filter: 'earring',  label: 'Earrings',  match: (t) => /earring/i.test(t) },
    { filter: 'bracelet', label: 'Bracelets', match: (t) => /bracelet|bangle|cuff/i.test(t) },
    { filter: 'necklace', label: 'Necklaces', match: (t) => /necklace|chain|pendant/i.test(t) },
    { filter: 'ring',     label: 'Rings',     match: (t) => /\bring\b/i.test(t) && !/earring/i.test(t) },
  ];

  function initFilters() {
    const filterBar = document.getElementById('b3-filters');
    if (!filterBar || !refs.grid) return;

    const existing = new Set();
    refs.grid.querySelectorAll('.b3-card[data-product-type]').forEach((c) => {
      if (c.dataset.productType) existing.add(c.dataset.productType);
    });

    CATEGORIES.forEach(({ filter, label, match }) => {
      const hasProducts = [...existing].some((t) => match(t));
      if (!hasProducts) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-filter-btn';
      btn.dataset.filter = filter;
      btn.textContent = label;
      filterBar.appendChild(btn);
    });

    filterBar.addEventListener('click', onFilterClick);
  }

  function onFilterClick(e) {
    const btn = e.target.closest('.bundle-filter-btn');
    if (!btn) return;
    const filter = btn.dataset.filter;
    document.querySelectorAll('.bundle-filter-btn').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    const cat = CATEGORIES.find((c) => c.filter === filter);
    refs.grid.querySelectorAll('.b3-card').forEach((card) => {
      const t = card.dataset.productType || '';
      const show = filter === 'all' || (cat && cat.match(t));
      card.style.display = show ? '' : 'none';
    });
  }

  // ── Grid click ──────────────────────────────────────────────────────────────

  function onGridClick(e) {
    // Gallery arrows (prev/next on card images)
    const prevArrow = e.target.closest('[data-action="gallery-prev"]');
    if (prevArrow) { navigateCardGallery(prevArrow.closest('.b3-card'), -1); return; }
    const nextArrow = e.target.closest('[data-action="gallery-next"]');
    if (nextArrow) { navigateCardGallery(nextArrow.closest('.b3-card'), 1); return; }

    // Quick View button
    const qvBtn = e.target.closest('[data-action="quick-view"]');
    if (qvBtn) {
      const card = qvBtn.closest('.b3-card');
      if (card) { const data = readCardData(card); if (data) openQuickView(card, data); }
      return;
    }

    // Click anywhere on the image area (except buttons) → Quick View
    const media = e.target.closest('.b3-card__media');
    if (media && !e.target.closest('button')) {
      const card = media.closest('.b3-card');
      if (card) { const data = readCardData(card); if (data) openQuickView(card, data); }
      return;
    }

    // ADD button → always opens QV modal (Louise Carter style)
    const btn = e.target.closest('[data-action="bundle-add"]');
    if (!btn || btn.disabled) return;
    const card = btn.closest('.b3-card');
    if (!card) return;
    if (items.length >= BUNDLE_SIZE) return;
    const data = readCardData(card);
    if (!data) return;
    openQuickView(card, data);
  }

  // ── Grid touchend (mobile single-tap fix) ──────────────────────────────────
  // On touch devices the browser first fires touchend, then synthesises a click
  // ~300ms later. If the card has a :hover transform the card shifts on first tap
  // and the synthetic click lands in the wrong place. We handle ADD directly on
  // touchend and call preventDefault() so the synthetic click is never generated.
  //
  // IMPORTANTE: também precisamos distinguir um TAP real de um SCROLL/SWIPE
  // que passa por cima do botão. Sem essa checagem, rolar a página com o
  // dedo apoiado sobre o botão ADD disparava o clique mesmo sem intenção —
  // o touchend sempre dispara ao soltar o dedo, independente de ter havido
  // movimento entre o touchstart e o touchend. A correção: rastrear a
  // posição inicial do toque e só considerar "tap" se o dedo não se moveu
  // mais que uma margem pequena (10px), que é o limiar padrão usado pela
  // maioria dos navegadores e bibliotecas para diferenciar tap de scroll.

  const TAP_MOVE_THRESHOLD = 10; // px
  let gridTouchStartX = 0;
  let gridTouchStartY = 0;

  function onGridTouchStart(e) {
    if (!e.touches || !e.touches[0]) return;
    gridTouchStartX = e.touches[0].clientX;
    gridTouchStartY = e.touches[0].clientY;
  }

  function onGridTouchEnd(e) {
    const btn = e.target.closest('[data-action="bundle-add"]');
    if (!btn || btn.disabled) return;

    // Calcula o quanto o dedo se moveu entre touchstart e touchend. Se
    // moveu mais que o limiar, foi um scroll/swipe — ignora, deixa o
    // navegador rolar a página normalmente, sem abrir o modal.
    const touch = (e.changedTouches && e.changedTouches[0]) || null;
    if (touch) {
      const dx = Math.abs(touch.clientX - gridTouchStartX);
      const dy = Math.abs(touch.clientY - gridTouchStartY);
      if (dx > TAP_MOVE_THRESHOLD || dy > TAP_MOVE_THRESHOLD) return;
    }

    const card = btn.closest('.b3-card');
    if (!card || items.length >= BUNDLE_SIZE) return;
    const data = readCardData(card);
    if (!data) return;
    e.preventDefault();
    openQuickView(card, data);
  }

  // ── Bundle state mutations ───────────────────────────────────────────────────

  function addItem(card, variantId, productImage, variantImage, variantTitle) {
    if (items.length >= BUNDLE_SIZE) return;

    const data = readCardData(card);
    if (!data) return;

    items.push({
      productId:    data.productId,
      variantId,
      title:        data.title,
      image:        variantImage || productImage,
      displayTitle: (variantTitle && variantTitle !== 'Default Title') ? variantTitle : '',
      uid:          ++uidCounter,
    });

    refs.grid.querySelectorAll('.b3-card').forEach(syncCardState);
    renderBar();
  }

  function removeItem(index) {
    if (!items[index]) return;
    items.splice(index, 1);
    refs.grid.querySelectorAll('.b3-card').forEach(syncCardState);
    renderBar();
  }

  // ── Card state sync (called after every add / remove) ────────────────────────

  function syncCardState(card) {
    const productId = card.dataset.productId;
    const count     = items.filter((i) => i.productId === productId).length;
    const isFull    = items.length >= BUNDLE_SIZE;

    card.classList.toggle('is-selected', count > 0);
    card.classList.toggle('is-dimmed',   isFull && count === 0);

    // Re-enable / disable the ADD button based solely on bundle fullness.
    // Only touch available-product buttons (those that have the bag icon).
    const addBtn = card.querySelector('[data-action="bundle-add"]');
    if (addBtn && addBtn.querySelector('.b3-card__add-icon')) {
      addBtn.disabled = isFull;
    }

    // Count badge — visible only when the same product is added more than once.
    let badge = card.querySelector('.b3-card__count-badge');
    if (count > 1) {
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'b3-card__count-badge';
        card.querySelector('.b3-card__media')?.appendChild(badge);
      }
      badge.textContent = `×${count}`;
    } else if (badge) {
      badge.remove();
    }
  }

  // ── Card image gallery ────────────────────────────────────────────────────────

  function initCardGalleries() {
    refs.grid.querySelectorAll('.b3-card').forEach((card) => {
      const data = readCardData(card);
      if (!data || !data.images || data.images.length < 2) return;

      card._imgIdx = 0;
      const media = card.querySelector('.b3-card__media');
      if (!media) return;

      const dotsEl = document.createElement('div');
      dotsEl.className = 'bnd-card-dots';
      data.images.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'bnd-card-dot' + (i === 0 ? ' is-active' : '');
        dotsEl.appendChild(dot);
      });
      media.appendChild(dotsEl);

      const prevEl = document.createElement('button');
      prevEl.type = 'button';
      prevEl.className = 'bnd-card-arrow bnd-card-arrow--prev';
      prevEl.dataset.action = 'gallery-prev';
      prevEl.setAttribute('aria-label', 'Previous image');
      prevEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';

      const nextEl = document.createElement('button');
      nextEl.type = 'button';
      nextEl.className = 'bnd-card-arrow bnd-card-arrow--next';
      nextEl.dataset.action = 'gallery-next';
      nextEl.setAttribute('aria-label', 'Next image');
      nextEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

      media.appendChild(prevEl);
      media.appendChild(nextEl);

      // Mobile swipe
      let swipeX = 0;
      media.addEventListener('touchstart', (e) => { swipeX = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - swipeX;
        if (Math.abs(dx) > 40) navigateCardGallery(card, dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function navigateCardGallery(card, dir) {
    if (!card) return;
    const data = readCardData(card);
    if (!data || !data.images || data.images.length < 2) return;

    const total = data.images.length;
    card._imgIdx = (((card._imgIdx || 0) + dir) % total + total) % total;

    const img = card.querySelector('.b3-card__media > img');
    if (img) img.src = data.images[card._imgIdx];

    card.querySelectorAll('.bnd-card-dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === card._imgIdx);
    });
  }

  // ── Quick View modal ──────────────────────────────────────────────────────────

  function openQuickView(card, data) {
    if (!refs.qvModal) return;
    qvCard   = card;
    qvImgIdx = 0;

    refs.qvBody.innerHTML = buildQVHTML(data);

    const gallery = document.getElementById('b3-qv-gallery');
    if (gallery) {
      let tx = 0;
      gallery.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) setQVImage(qvImgIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // Guardar a posição atual do scroll ANTES de travar o body.
    qvScrollY = window.scrollY || window.pageYOffset || 0;

    refs.qvModal.classList.add('is-open');
    refs.qvModal.removeAttribute('aria-hidden');
    document.documentElement.classList.add('bnd-qv-open');
    document.body.classList.add('bnd-qv-open');
    // Aplicar o top SOMENTE depois que position:fixed já está ativo
    // (classe bnd-qv-open acima), garantindo ordem consistente entre
    // navegadores e evitando qualquer estado intermediário onde o
    // body tem top negativo sem estar fixed ainda.
    document.body.style.top = `-${qvScrollY}px`;
    setTimeout(() => refs.qvClose?.focus({ preventScroll: true }), 60);
  }

  function closeQuickView() {
    if (!refs.qvModal) return;
    refs.qvModal.classList.remove('is-open');
    refs.qvModal.setAttribute('aria-hidden', 'true');

    // ORDEM CRÍTICA para evitar o "flash" de salto visual ao fechar:
    // o body está com position:fixed + top:-XXXpx (técnica de scroll
    // lock). Se removermos primeiro a classe (que tira o
    // position:fixed) e SÓ DEPOIS limparmos o style.top, existe um
    // frame onde o body já não é mais "fixed" mas ainda tem
    // top:-XXXpx no inline style — nesse frame, "top" não tem efeito
    // nenhum (só funciona em elementos posicionados), então o
    // navegador renderiza o body na posição real do documento (scroll
    // 0), causando o salto visual para o topo antes do scrollTo
    // corrigir de volta.
    //
    // A ordem correta é: 1) restaurar o scroll ENQUANTO ainda está
    // fixed, 2) remover position:fixed e top JUNTOS no mesmo tick.
    const targetScrollY = qvScrollY;

    document.documentElement.classList.remove('bnd-qv-open');
    document.body.classList.remove('bnd-qv-open');
    document.body.style.top = '';
    // O tema tem `scroll-behavior: smooth` aplicado globalmente no <html>
    // (base.css), o que faz QUALQUER scrollTo() animar suavemente em vez
    // de saltar instantaneamente. Isso é o que causava o efeito visual de
    // "a página volta para o topo e rola rapidamente até a posição certa"
    // ao fechar o modal — o scrollTo estava sendo animado pelo navegador.
    // A correção: forçar behavior:'instant' explicitamente nesta chamada,
    // que sobrescreve o comportamento suave só aqui, sem alterar o
    // scroll-behavior global do tema (que continua suave em links normais
    // de âncora em outras páginas).
    window.scrollTo({ top: targetScrollY, left: 0, behavior: 'instant' });

    qvCard = null;
  }

  function buildQVHTML(data) {
    const imgs     = (data.images && data.images.length) ? data.images : (data.image ? [data.image] : []);
    const isFull   = items.length >= BUNDLE_SIZE;
    const singleV  = data.isSingleVariant && data.variants && data.variants[0];

    // Auto-resolve single variant
    const autoV    = (singleV && singleV.available) ? singleV : null;
    const addNum   = items.length + 1;
    const currentCount = items.length;
    const btnLabel = isFull
      ? 'BUNDLE IS FULL'
      : currentCount === 0
        ? 'ADD TO CART'
        : `ADD TO CART (${addNum}/${BUNDLE_SIZE})`;
    // Para multi-variante com auto-select (1 valor): pre-resolve a variante
    let resolvedV = autoV;
    if (!resolvedV && data.options && data.options.length) {
      // Tenta resolver se todos os options tiverem apenas 1 valor disponível
      const allSingle = data.options.every(opt => opt.values.length === 1);
      if (allSingle) {
        const firstAvails = data.options.map((opt, i) =>
          data.variants.find(v => v['option' + (i+1)] === opt.values[0] && v.available)
        );
        if (firstAvails.every(Boolean)) {
          resolvedV = data.variants.find(v =>
            data.options.every((opt, i) => v['option' + (i+1)] === opt.values[0])
          ) || null;
        }
      }
    }
    const autoAttrs = resolvedV
      ? ` data-variant-id="${resolvedV.id}" data-variant-image="${esc(resolvedV.image || '')}" data-variant-title="${esc(resolvedV.title || '')}"`
      : '';
    // Botão desabilitado até variante ser selecionada (exceto auto-resolvido)
    const btnDisabled = isFull || (!resolvedV && !data.isSingleVariant);

    let html = '';

    // ── Gallery ──────────────────────────────────────────────────
    html += '<div class="bnd-qv__gallery" id="b3-qv-gallery"><div class="bnd-qv__imgs">';
    imgs.forEach((src, i) => {
      html += `<img class="bnd-qv__img${i === 0 ? ' is-active' : ''}" src="${esc(src)}" alt="${esc(data.title)}" loading="${i === 0 ? 'eager' : 'lazy'}">`;
    });
    html += '</div>';
    if (imgs.length > 1) {
      html += '<button class="bnd-qv__arrow bnd-qv__arrow--prev" id="b3-qv-prev" type="button" aria-label="Previous image"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg></button>';
      html += '<button class="bnd-qv__arrow bnd-qv__arrow--next" id="b3-qv-next" type="button" aria-label="Next image"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg></button>';
      html += '<div class="bnd-qv__dots">';
      imgs.forEach((_, i) => { html += `<span class="bnd-qv__dot${i === 0 ? ' is-active' : ''}" data-qv-dot="${i}"></span>`; });
      html += '</div>';
    }
    html += '</div>';

    // ── Content ───────────────────────────────────────────────────
    html += '<div class="bnd-qv__content">';

    // Title bold + type below (auto from product.type)
    html += `<h2 class="bnd-qv__title">${esc(data.title)}</h2>`;
    if (data.productType) html += `<p class="bnd-qv__type">${esc(data.productType)}</p>`;

    // Waterproof badge — full-width box with border + checkmark
    html += `<div class="bnd-qv__wp-badge">
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
      <span>100% Waterproof · 18K PVD Gold · Hypoallergenic</span>
    </div>`;

    // Variant options — all products show options, single-val auto-selected
    if (data.options && data.options.length) {
      data.options.forEach((opt, i) => {
        const firstAvail = opt.values.find((v) =>
          data.variants.some((vv) => vv['option' + (i+1)] === v && vv.available)
        );
        const autoSel = opt.values.length === 1 ? firstAvail : null;

        html += `<div class="bnd-qv__option" data-pos="${i}">`;
        html += `<p class="bnd-qv__opt-label"><strong>${esc(opt.name)}</strong>${autoSel ? ` <span class="bnd-qv__sel-val">— ${esc(autoSel)}</span>` : ''}</p>`;
        html += '<div class="bnd-qv__opt-values">';
        opt.values.forEach((val) => {
          const hasStock = data.variants.some((v) => v['option' + (i+1)] === val && v.available);
          const isAuto   = val === autoSel;
          const pillStyle = isAuto ? ` style="${pillColorStyle(val)}"` : '';
          html += `<button
            class="bnd-qv__opt-pill${hasStock ? '' : ' is-unavailable'}${isAuto ? ' is-selected' : ''}"
            data-opt-index="${i}" data-val="${esc(val)}"
            data-pill-color="${esc(pillColorBg(val))}"
            data-pill-text="${esc(pillColorText(val))}"
            type="button" ${hasStock ? '' : 'disabled'}${pillStyle}
          >${esc(val)}</button>`;
        });
        html += '</div></div>';
      });
    }

    // Free Shipping badge — yellow tinted
    html += `<div class="bnd-qv__ship-badge">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
      <span><strong>Free Shipping</strong> — Fast Delivery</span>
    </div>`;

    // Benefit tags row
    html += `<div class="bnd-qv__tags">
      <span class="bnd-qv__tag">100% Waterproof</span>
      <span class="bnd-qv__tag">Free Shipping</span>
      <span class="bnd-qv__tag">Lifetime Warranty</span>
    </div>`;

    html += '</div>';

    // ── Footer (botão Add to Cart) ─────────────────────────────────
    // Fica como elemento irmão de .bnd-qv__gallery e .bnd-qv__content
    // (não mais dentro do content), para no desktop poder ocupar uma
    // linha própria de largura total via grid-area, igual à
    // referência visual (rodapé inteiro embaixo das 2 colunas).
    html += '<div class="bnd-qv__footer">';
    html += `<button class="bnd-qv__add-btn" id="b3-qv-add" type="button"${btnDisabled ? ' disabled' : ''}${autoAttrs}>${btnLabel}</button>`;
    html += '</div>';

    return html;
  }

  function setQVImage(idx) {
    if (!refs.qvBody) return;
    const imgs = refs.qvBody.querySelectorAll('.bnd-qv__img');
    if (!imgs.length) return;
    const total = imgs.length;
    qvImgIdx = ((idx % total) + total) % total;
    imgs.forEach((img, i) => img.classList.toggle('is-active', i === qvImgIdx));
    refs.qvBody.querySelectorAll('.bnd-qv__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === qvImgIdx);
    });
  }

  function resolveQVVariant() {
    if (!qvCard || !refs.qvBody) return;
    const data = readCardData(qvCard);
    if (!data) return;

    const addBtn = document.getElementById('b3-qv-add');
    if (!addBtn) return;

    if (items.length >= BUNDLE_SIZE) { addBtn.disabled = true; return; }

    // Para cada opção: pegar valor selecionado (clicado ou único disponível)
    const selections = data.options.map((opt, i) => {
      const sel = refs.qvBody.querySelector(`.bnd-qv__option[data-pos="${i}"] .is-selected`);
      if (sel) return sel.dataset.val;
      // Auto-select se só tem 1 valor disponível
      if (opt.values.length === 1) return opt.values[0];
      return null;
    });

    if (selections.some((s) => s === null)) {
      addBtn.disabled = true;
      return;
    }

    const match = data.variants.find((v) =>
      selections.every((sel, i) => v[`option${i + 1}`] === sel)
    );

    if (match && match.available) {
      addBtn.disabled             = false;
      addBtn.dataset.variantId    = String(match.id);
      addBtn.dataset.variantImage = match.image || '';
      addBtn.dataset.variantTitle = match.title || '';
    } else {
      addBtn.disabled = true;
      delete addBtn.dataset.variantId;
    }
  }

  function onQVClick(e) {
    if (e.target.closest('#b3-qv-prev')) { setQVImage(qvImgIdx - 1); return; }
    if (e.target.closest('#b3-qv-next')) { setQVImage(qvImgIdx + 1); return; }

    const dot = e.target.closest('[data-qv-dot]');
    if (dot) { setQVImage(parseInt(dot.dataset.qvDot, 10)); return; }

    const optBtn = e.target.closest('.bnd-qv__opt-pill:not([disabled]), .bnd-qv__opt-val:not([disabled])');
    if (optBtn) {
      const pos   = parseInt(optBtn.dataset.optIndex, 10);
      const group = refs.qvBody.querySelector(`.bnd-qv__option[data-pos="${pos}"] .bnd-qv__opt-values`);
      // Reset todos os pills do grupo
      group?.querySelectorAll('.bnd-qv__opt-pill, .bnd-qv__opt-val').forEach((b) => {
        b.classList.remove('is-selected');
        b.style.removeProperty('background');
        b.style.removeProperty('border-color');
        b.style.removeProperty('color');
      });
      // Marcar selecionado com cor
      optBtn.classList.add('is-selected');
      optBtn.style.background  = '#8B6651';
      optBtn.style.borderColor = '#8B6651';
      optBtn.style.color       = '#fff';
      // Atualizar label
      const label = refs.qvBody.querySelector(`.bnd-qv__option[data-pos="${pos}"] .bnd-qv__sel-val`);
      if (label) label.textContent = `— ${optBtn.dataset.val}`;
      // Resolver variante após marcar
      resolveQVVariant();
      return;
    }

    const addBtn = e.target.closest('#b3-qv-add');
    if (addBtn && !addBtn.disabled) {
      if (!qvCard || items.length >= BUNDLE_SIZE) return;
      const variantId    = parseInt(addBtn.dataset.variantId, 10);
      const variantImage = addBtn.dataset.variantImage || null;
      const variantTitle = addBtn.dataset.variantTitle || '';
      const cardData     = readCardData(qvCard);
      addItem(qvCard, variantId, cardData ? cardData.image : null, variantImage, variantTitle);
      closeQuickView();
    }
  }

  // ── Bottom bar rendering ─────────────────────────────────────────────────────

  function renderBar() {
    refs.count.textContent = String(items.length);

    const slots = refs.slots.querySelectorAll('.b3-bar__slot');

    slots.forEach((slot, i) => {
      const item = items[i];
      if (item) {
        slot.className = 'b3-bar__slot is-filled';
        slot.innerHTML = item.image
          ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">
             <button class="b3-bar__remove" data-remove-index="${i}" type="button" aria-label="Remove ${esc(item.title)}">
               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
             </button>`
          : `<button class="b3-bar__remove" data-remove-index="${i}" type="button" aria-label="Remove ${esc(item.title)}">
               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
             </button>`;
      } else {
        slot.className = 'b3-bar__slot is-empty';
        slot.innerHTML = `<span class="b3-bar__slot-num">${i + 1}</span>`;
      }
    });

    const complete = items.length === BUNDLE_SIZE;
    const wasComplete = refs.checkoutBtn.classList.contains('is-active');
    refs.checkoutBtn.disabled = !complete;
    refs.checkoutBtn.setAttribute('aria-disabled', String(!complete));
    refs.checkoutBtn.classList.toggle('is-active', complete);
    refs.checkoutBtn.setAttribute(
      'aria-label',
      complete ? 'Proceed to checkout' : 'Proceed to checkout — select 3 items first'
    );
    // Confetti when bundle just became complete
    if (complete && !wasComplete) launchConfetti();
  }

  function onSlotsClick(e) {
    const btn = e.target.closest('[data-remove-index]');
    if (!btn) return;
    removeItem(parseInt(btn.dataset.removeIndex, 10));
  }

  // ── Variant overlay ──────────────────────────────────────────────────────────

  function openOverlay(card, data) {
    activeCard = card;
    refs.content.innerHTML = buildPickerHTML(data);

    const isMobile = window.innerWidth < 750;
    refs.panel.classList.toggle('is-popover', !isMobile);
    refs.panel.classList.toggle('is-bottom-sheet', isMobile);

    if (!isMobile) {
      positionPopover(card);
    } else {
      // Bottom sheet: CSS handles the position.
      refs.panel.style.top  = '';
      refs.panel.style.left = '';
    }

    refs.overlay.classList.add('is-open');
    refs.overlay.removeAttribute('aria-hidden');
    document.body.classList.add('bundle-overlay-open');

    // Move focus into the panel for keyboard users.
    setTimeout(() => refs.closeBtn.focus({ preventScroll: true }), 60);
  }

  function closeOverlay() {
    refs.overlay.classList.remove('is-open');
    refs.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bundle-overlay-open');
    activeCard = null;
  }

  /**
   * Position the popover to the right (or left) of the product card.
   * Uses fixed coordinates since the panel is position:fixed.
   */
  function positionPopover(card) {
    const rect     = card.getBoundingClientRect();
    const panelW   = 300;
    const margin   = 14;
    const vpW      = window.innerWidth;
    const vpH      = window.innerHeight;

    let left = rect.right + margin;
    if (left + panelW > vpW - margin) left = rect.left - panelW - margin;
    if (left < margin) left = margin;

    // Estimate panel height; clamp so it stays in view.
    const estimatedH = 420;
    let top = rect.top;
    if (top + estimatedH > vpH - margin) top = vpH - estimatedH - margin;
    if (top < margin) top = margin;

    refs.panel.style.top  = `${top}px`;
    refs.panel.style.left = `${left}px`;
  }

  // ── Variant picker HTML builder ──────────────────────────────────────────────

  function buildPickerHTML(data) {
    const { productId, title, image, variants, options } = data;

    let html = `<div class="bundle-picker" data-product-id="${productId}">`;

    html += `<div class="bundle-picker__head">`;
    if (image) html += `<img class="bundle-picker__img" src="${esc(image)}" alt="${esc(title)}" loading="lazy">`;
    html += `<p class="bundle-picker__product-title">${esc(title)}</p>`;
    html += `</div>`;

    options.forEach((opt, i) => {
      html += `<div class="bundle-picker__option" data-pos="${i}">`;
      html += `<p class="bundle-picker__opt-label">${esc(opt.name)}</p>`;
      html += `<div class="bundle-picker__opt-values">`;

      opt.values.forEach((val) => {
        // A value is available if at least one variant with that option value is in stock.
        const hasStock = variants.some(
          (v) => v[`option${i + 1}`] === val && v.available
        );

        html += `<button
          class="bundle-picker__opt-val${hasStock ? '' : ' is-unavailable'}"
          data-opt-index="${i}"
          data-val="${esc(val)}"
          type="button"
          ${hasStock ? '' : 'disabled'}
        >${esc(val)}</button>`;
      });

      html += `</div></div>`;
    });

    html += `<button class="bundle-picker__add-btn" id="b3-picker-add" type="button" disabled>
        ADD TO CART
    </button>`;

    html += `</div>`;
    return html;
  }

  // ── Picker click handler (option selection + "add to box") ──────────────────

  function onPickerClick(e) {
    const optBtn = /** @type {HTMLButtonElement|null} */ (
      e.target.closest('.bundle-picker__opt-val:not([disabled])')
    );
    const addBtn = /** @type {HTMLButtonElement|null} */ (
      e.target.closest('#b3-picker-add')
    );

    if (optBtn) {
      const pos   = parseInt(optBtn.dataset.optIndex, 10);
      const group = refs.content.querySelector(
        `.bundle-picker__option[data-pos="${pos}"] .bundle-picker__opt-values`
      );
      group.querySelectorAll('.bundle-picker__opt-val').forEach((b) =>
        b.classList.remove('is-selected')
      );
      optBtn.classList.add('is-selected');
      resolveVariant();
    }

    if (addBtn && !addBtn.disabled) {
      if (!activeCard) return;

      const variantId    = parseInt(addBtn.dataset.variantId, 10);
      const variantImage = addBtn.dataset.variantImage || null;
      const variantTitle = addBtn.dataset.variantTitle || '';
      const data         = readCardData(activeCard);

      addItem(activeCard, variantId, data ? data.image : null, variantImage, variantTitle);
      closeOverlay();
    }
  }

  /**
   * Check whether all options are selected and, if so, find the matching variant.
   * Enables/disables the "ADD TO BOX" button accordingly.
   */
  function resolveVariant() {
    if (!activeCard) return;

    const data = readCardData(activeCard);
    if (!data) return;

    const { variants, options } = data;

    // Collect the currently selected value for each option dimension.
    const selections = options.map((_, i) => {
      const sel = refs.content.querySelector(
        `.bundle-picker__option[data-pos="${i}"] .bundle-picker__opt-val.is-selected`
      );
      return sel ? sel.dataset.val : null;
    });

    const pickerAddBtn = /** @type {HTMLButtonElement|null} */ (
      document.getElementById('b3-picker-add')
    );
    if (!pickerAddBtn) return;

    // All dimensions must be chosen before we can resolve a variant.
    if (selections.some((s) => s === null)) {
      pickerAddBtn.disabled = true;
      return;
    }

    const match = variants.find((v) =>
      selections.every((sel, i) => v[`option${i + 1}`] === sel)
    );

    if (match && match.available) {
      pickerAddBtn.disabled               = false;
      pickerAddBtn.dataset.variantId      = String(match.id);
      pickerAddBtn.dataset.variantImage   = match.image || '';
      pickerAddBtn.dataset.variantTitle   = match.title || '';
    } else {
      pickerAddBtn.disabled = true;
      delete pickerAddBtn.dataset.variantId;
    }
  }

  // ── Checkout ─────────────────────────────────────────────────────────────────

  async function onCheckout() {
    if (items.length < BUNDLE_SIZE) return;

    const btn = refs.checkoutBtn;
    btn.disabled    = true;
    btn.textContent = 'Adding…';
    btn.classList.add('is-loading');

    try {
      // 1. Clear the existing cart so only bundle items land in checkout.
      const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
      if (!clearRes.ok) throw new Error(`clear error ${clearRes.status}`);

      // 2. Add the 3 chosen pieces as SEPARATE cart lines (each with a
      // hidden _bundle_item:true property, same pattern as the waterproof
      // bundle) PLUS the paid bundle item. This makes fulfillment apps
      // like SIHI Dropshipping see each real product with its own image,
      // SKU and variant — they only read actual line items, not custom
      // line item properties, so a single merged line item was invisible
      // to them. The paid bundle item still carries "Selection 1/2/3" as
      // HIDDEN properties (underscore prefix) — they don't show on the
      // customer-facing cart/checkout (redundant now that each product is
      // its own line item), but they ARE visible in the Shopify Admin
      // order view for a quick human-readable reference.
      const bundleItemTitles = items.map((item) => item.title);

      const bundleProperties = {};
      bundleItemTitles.forEach((label, i) => {
        bundleProperties[`_Selection ${i + 1}`] = label;
      });
      bundleProperties['_bundle_variant_ids'] = items.map((i) => i.variantId).join(',');

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            ...items.map((item) => ({
              id: item.variantId,
              quantity: 1,
              properties: { '_bundle_item': 'true' },
            })),
            {
              id: BUNDLE_PAID_VARIANT_ID,
              quantity: 1,
              properties: bundleProperties,
            },
          ],
        }),
      });

      if (!addRes.ok) {
        const err = await addRes.json().catch(() => ({}));
        throw new Error(err.description || `cart/add error ${addRes.status}`);
      }

      // 3. Redirect to Shopify's native checkout.
      window.location.href = '/checkout';
    } catch (err) {
      console.error('[bundle-waterproof] checkout error:', err);

      btn.classList.remove('is-loading');
      btn.classList.add('is-active');
      btn.disabled    = false;
      btn.textContent = 'Error — try again';

      setTimeout(() => {
        btn.textContent = 'CHECKOUT';
      }, 3500);
    }
  }

  // ── Helpers ──────────────────────────────────────────────────────────────────

  /**
   * Read the JSON data embedded inside a bundle card's <script> tag.
   */
  function readCardData(card) {
    const script = card.querySelector('.b3-card__json');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('[bundle-waterproof] failed to parse card JSON:', e);
      return null;
    }
  }


  // ── Confetti celebration ─────────────────────────────────────────────────────

  function launchConfetti() {
    const canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
    document.body.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;

    const colors = ['#8B6651','#C9993A','#D4B896','#F5EDE4','#7A5843','#E8D5B0'];
    const pieces = Array.from({ length: 120 }, () => ({
      x:     Math.random() * canvas.width,
      y:     Math.random() * -canvas.height * 0.5,
      w:     6 + Math.random() * 8,
      h:     10 + Math.random() * 8,
      color: colors[Math.floor(Math.random() * colors.length)],
      rot:   Math.random() * Math.PI * 2,
      vx:    (Math.random() - 0.5) * 3,
      vy:    2 + Math.random() * 4,
      vr:    (Math.random() - 0.5) * 0.2,
      opacity: 1,
    }));

    let frame = 0;
    const maxFrames = 160;

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach((p) => {
        p.x  += p.vx;
        p.y  += p.vy;
        p.rot += p.vr;
        p.vy += 0.08; // gravity
        if (frame > maxFrames * 0.6) p.opacity -= 0.02;
        if (p.opacity <= 0) return;
        ctx.save();
        ctx.globalAlpha = Math.max(0, p.opacity);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      frame++;
      if (frame < maxFrames + 40) {
        requestAnimationFrame(draw);
      } else {
        canvas.remove();
      }
    }
    draw();
  }

  // Colour helpers for option pills
  function pillColorBg(val) {
    // Todas as opções usam o marrom da marca quando selecionadas
    return '#8B6651';
  }
  function pillColorText(val) {
    return '#fff';
  }
  function pillColorStyle(val) {
    return `background:${pillColorBg(val)};border-color:${pillColorBg(val)};color:${pillColorText(val)};`;
  }

  /**
   * Escape a value for safe use inside HTML attributes and text content.
   */
  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Reset seguro ao voltar do checkout ──────────────────────────────────────
  //
  // Problema dos approaches anteriores: tanto disparar reset no evento
  // `load` quanto usar sessionStorage como flag dependem de mecanismos
  // que falham na prática nesta loja, porque o checkout do Shopify abre
  // em um domínio DIFERENTE do storefront (ex: checkout.shopify.com),
  // já que não há domínio de checkout personalizado configurado.
  // sessionStorage é isolado por origem/domínio — uma flag setada no
  // domínio da loja nunca é vista quando o cliente volta, porque o
  // navegador trata isso como armazenamento completamente separado.
  //
  // Solução robusta que funciona independente de domínio: consultar o
  // carrinho REAL do Shopify via /cart.js (uma chamada de API ao
  // servidor, não armazenamento local do navegador). Se o produto
  // bundle pago já estiver no carrinho quando a página da coleção
  // carrega, isso só pode significar uma coisa: o cliente já passou
  // pelo fluxo de checkout antes (completou ou abandonou) e voltou —
  // então resetamos tudo para ele recomeçar do zero.

  async function resetBundleState() {
    items.length = 0;
    refs.grid?.querySelectorAll('.b3-card').forEach(syncCardState);
    renderBar();
    if (refs.checkoutBtn) {
      refs.checkoutBtn.disabled = true;
      refs.checkoutBtn.classList.remove('is-active', 'is-loading');
      refs.checkoutBtn.textContent = 'CHECKOUT';
    }
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
    } catch (err) {
      console.error('[bundle-3for1] cart reset on return failed:', err);
    }
  }

  // Consulta o carrinho real do Shopify. Retorna true se resetou o
  // estado (porque encontrou o bundle pago já no carrinho), false caso
  // contrário (carrinho vazio ou sem o bundle — fluxo normal).
  async function checkCartAndMaybeReset() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return false;
      const cart = await res.json();
      const hasBundleInCart = cart.items?.some(
        (item) => item.variant_id === BUNDLE_PAID_VARIANT_ID
      );
      if (hasBundleInCart) {
        await resetBundleState();
        return true;
      }
      return false;
    } catch (err) {
      console.error('[bundle-3for1] cart check failed:', err);
      return false;
    }
  }

  // Cobre o caso de bfcache real (Safari principalmente), onde a página é
  // restaurada do cache sem rodar init() de novo. Nesse cenário, refs.*
  // já existem de antes (a página nunca foi destruída de fato) — então
  // basta reconsultar o carrinho real do mesmo jeito.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) checkCartAndMaybeReset();
  });

  // Fallback adicional: se por algum motivo o botão ficar visualmente
  // travado em "Adding…" (ex: a requisição de /cart/add.js travou no
  // meio do caminho sem dar erro nem sucesso), destrava ele quando a
  // aba voltar a ficar visível.
  let wasHidden = false;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      wasHidden = true;

    } else if (document.visibilityState === 'visible' && wasHidden) {
      wasHidden = false;
      if (refs.checkoutBtn?.classList.contains('is-loading') || refs.checkoutBtn?.textContent.trim() === 'Adding…') {
        resetBundleState();
      }
    }
  });
})();
